module.exports = __webpack_public_path__ + "static/media/sort-circle.4de58155.svg";